<script>
  // Mirrors the shared Rails partial at `app/views/shared/_boolean-input.html.slim` so form
  // booleans look identical whether they're rendered server-side (Slim) or client-side
  // (Svelte). Styling comes from `.boolean-container` / `.boolean-segment` in forms.css,
  // including the teal variant when `primary` is set.
  import { cn } from '@lib/utils'

  let {
    value = $bindable(false),
    primary = false,
    disabled = false,
    name,
    onChange,
    class: className,
  } = $props()

  // Radios within the same container must share a name; generate one per instance so multiple
  // BooleanControls on the same page don't collide.
  const inputName = name ?? `boolean-${Math.random().toString(36).slice(2, 10)}`

  function setValue(newValue) {
    if (disabled) return
    value = newValue
    onChange?.(newValue)
  }
</script>

<div class={cn("boolean-container", primary && "primary", className)}>
  <label class="boolean-segment px-3">
    <input
      type="radio"
      name={inputName}
      value="false"
      checked={value === false}
      {disabled}
      onchange={() => setValue(false)}
    />
    <span>Non</span>
  </label>
  <label class="boolean-segment px-3">
    <input
      type="radio"
      name={inputName}
      value="true"
      checked={value === true}
      {disabled}
      onchange={() => setValue(true)}
    />
    <span>Oui</span>
  </label>
</div>
